module.exports = __webpack_public_path__ + "static/media/Chenthoor_landscape_Logo.39da0a4e.png";